export class StatusMessageResultDto {
    message: string;
    isSuccessMessage: boolean; // Indicates if success status and display the message to the user
}
